import React from 'react'

const Modal = ({
                   person: {
                       born,
                       email,
                       employee_year,
                       first_employed,
                       image,
                       phone,
                       position,
                       text,
                   },
                   isActive,
                   onClose,
               }) => {
    return (
      <div className={`consultants__modal ${isActive ? 'opened' : 'hidden'}`}>
          <div className="consultants__modal-content-wrapper">
              <div className="consultants__modal-content">
                  <div>
                      {phone ? (
                        <div className="consultants__modal__item">
                            <span className="consultants__modal__title">Telefon:</span>
                            <a href={`tel:${phone}`} className="consultants__modal__text">
                                {phone}
                            </a>
                        </div>
                      ) : (
                         ''
                       )}
                  </div>
                  <div>
                      {email ? (
                        <div className="consultants__modal__item">
                            <span className="consultants__modal__title">E-post:</span>
                            <a
                              href={`mailto:${email}`}
                              className="consultants__modal__text"
                            >
                                {email}
                            </a>
                        </div>
                      ) : (
                         ''
                       )}
                  </div>
                  <div>
                      {position ? (
                        <div className="consultants__modal__item">
                <span className="consultants__modal__title">
                  Position inom Bylero:
                </span>
                            <span className="consultants__modal__text">{position}</span>
                        </div>
                      ) : (
                         ''
                       )}
                  </div>
                  <div>
                      {employee_year ? (
                        <div className="consultants__modal__item">
                <span className="consultants__modal__title">
                  Anställd vid Bylero:
                </span>
                            <span className="consultants__modal__text">
                  {employee_year}
                </span>
                        </div>
                      ) : (
                         ''
                       )}
                  </div>
                  <div>
                      {first_employed ? (
                        <div className="consultants__modal__item">
                <span className="consultants__modal__title">
                  Första anställningen inom aktuellt yrke:
                </span>
                            <span className="consultants__modal__text">
                  {first_employed}
                </span>
                        </div>
                      ) : (
                         ''
                       )}
                  </div>
                  <div>
                      {born ? (
                        <div className="consultants__modal__item">
                            <span className="consultants__modal__title">Född:</span>
                            <span className="consultants__modal__text">{born}</span>
                        </div>
                      ) : (
                         ''
                       )}
                  </div>
                  <div>
                      {text ? (
                        <div
                          className="consultants__modal__description wa-wysiwyg"
                          dangerouslySetInnerHTML={{ __html: text }}
                        />
                      ) : (
                         ''
                       )}
                  </div>
              </div>
              <div className="consultants__modal__gradient"/>
              <button className="consultants__modal__close" onClick={onClose}>
                  <img
                    src={`${window.MS_Ajax.rootDir}/images/close.svg`}
                    alt="close icon"
                  />
              </button>
          </div>
      </div>
    )
}

export default Modal
